export const SetLocalStorageItemSafely = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.log("Local Storage - Probably QuotaExceededError", e);
    // Todo: Probably got to have fallback or send analytics on quota exceeded
    // Ignore setting it
  }
};
